import React from 'react';
import './AboutUs.css';

const AboutUs: React.FC = () => {
  return (
    <div className='about-container'>
      <h1>About SAëF</h1>
      <p className='subtitle'>Elite Protection. Unmatched Discretion. Elevated Service.</p>

      <section className='about-section'>
        <p>
          Founded in 2025 in the vibrant city of Las Vegas, SAëF was established to set a new
          standard in executive protection and concierge services. Built by a team of seasoned
          entrepreneurs with over 50 years of combined experience, including distinguished service
          within the Department of Defense (DoD) and the Department of Homeland Security (DHS), SAëF
          merges federal-grade security with the sophistication of high-end lifestyle support.
        </p>
        <p>
          Our founders understood the evolving demands of VIPs, corporate leaders, entertainers, and
          international travelers—and created SAëF to be the trusted partner who anticipates and
          delivers security and comfort at every level.
        </p>
      </section>

      <section className='about-section'>
        <h2>Our Mission</h2>
        <p>
          At SAëF, our mission is to deliver bespoke security and concierge solutions that offer
          more than just protection—they offer peace of mind, operational efficiency, and
          luxury-level support tailored to your lifestyle.
        </p>
      </section>

      <section className='about-section'>
        <h2>What Makes SAëF Different</h2>

        <div className='about-feature'>
          <h3>Federal Agency Expertise</h3>
          <p>
            Our leadership draws from decades of experience protecting national interests. That same
            level of precision and discretion now protects your world.
          </p>
        </div>

        <div className='about-feature'>
          <h3>Luxury-Grade Personalization</h3>
          <p>
            SAëF provides more than safety—we offer a concierge experience designed to simplify and
            elevate every aspect of your day.
          </p>
        </div>

        <div className='about-feature'>
          <h3>Tailored Risk Management</h3>
          <p>
            Every client, every itinerary, every moment is assessed with unmatched attention to
            detail. Your protection is proactive, adaptive, and seamless.
          </p>
        </div>

        <div className='about-feature'>
          <h3>Elite Personnel</h3>
          <p>
            Our protection specialists and lifestyle coordinators are carefully selected for their
            professionalism, discretion, and integrity—many are veterans of elite military and
            intelligence communities.
          </p>
        </div>
      </section>

      <section className='about-section'>
        <h2>Services Offered by SAëF</h2>
        <ul className='services-list'>
          <li>Executive & Close Protection</li>
          <li>Secure Ground & Air Transportation</li>
          <li>Private Event & Venue Security</li>
          <li>International Travel Planning & Coordination</li>
          <li>High-Touch Lifestyle Concierge</li>
          <li>Threat Assessment & Risk Management</li>
        </ul>
      </section>
    </div>
  );
};

export default AboutUs;
